module.exports = function(locale, preview, filters) {
  return `
  fragment PageMetaDataFragment on PageMetaData {
    sys {
      id
    }
    __typename
    pageTitle
    metaTitle
    metaDescription
    metaKeywords
    ogImage:openGraphImage{
    url
  }
    openGraphPageTitle
    openGraphDescription
  }
 
  {
    productListCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}"}) {
      items {
        sys {
          id
        }
        name
        slug
        facet{
          title
          sys{
            id
          }
          name
          slug
          
        }
        facetCategory {
          sys {
            id
          }
          title
          uniqueId
        }
        parentPage {
          slug
        }
        pageMetadata {
          ...PageMetaDataFragment
        }
        breadcrumbTitle
        sitemapTitle
        pageContentCollection {
          items {
            sys {
              id
            }
          }
        }
      }
    }
    facetCategoryCollection(limit: 4, order: order_ASC,locale: "${locale}", preview: ${preview}) {
      items {
        sys {
          id
        }
        order
        title
        uniqueId
        facetCollection(limit: 30) {
          items {
            title
            sys {
              id
            }
            name
            slug
          }
        }
      }
    }
    productCollection (locale: "${locale}", preview: ${preview}){
      items {
        ratingAndReviewId
        slug
        featuredSort
        variantsCollection(limit:5){
          items{
            name
            variantName
            gtin
          }
        }
        fecetCollection(limit: 30) {
          items {
            sys {
              id
            }
            name
            title
            facetCategory {
              title
              uniqueId
            }
          }
        }
        productShortName
        slug
        shortDescription
        productName
        gtin
        heroImage {
          url
          description
        }
        addedOn
      }
    }
  }
  
`;
};
